export default __webpack_public_path__ + "static/media/QQT Demo with Nesting and CC.webmhd.fb226271.webm";